// filepath: client/src/routes/customerRoutes.js
import { lazy } from 'react';
import CustomerProtectedRoute from '#client/components/CustomerProtectedRoute';
import CustomerLayout from '#client/components/layout/CustomerLayout/CustomerLayout';
import VoucherDashboard from '#client/pages/VoucherDashboard/VoucherDashboard';
import ProgramPage from '#client/pages/Programs/Program';
import VoucherList from '#client/pages/VoucherDashboard/VoucherList';
import ManualVoucherDistribution from '#client/pages/VoucherDistribution/ManualVoucherDistribution';
import { RouteLoadingFallback } from '#client/components/common/RouteLoader';
import { programDashboardLoader } from '#client/routes/loaders/programDashboardLoader';

const ProgramManagementDashboard = lazy(() => import('#client/pages/Programs/ProgramManagementDashboard/ProgramManagementDashboard'));

const customerRoutes = [
    {
        path: '/',
        element: (
            <CustomerProtectedRoute>
                <CustomerLayout />
            </CustomerProtectedRoute>
        ),
        children: [
            {
                path: 'voucher-dashboard',
                element: (
                    <CustomerProtectedRoute>
                        <VoucherDashboard />
                    </CustomerProtectedRoute>
                ),
            },
            {
                path: 'customer/programs',
                element: (
                    <CustomerProtectedRoute>
                        <ProgramManagementDashboard />
                    </CustomerProtectedRoute>
                ),
                loader: programDashboardLoader,
                HydrateFallback: RouteLoadingFallback,
            },
            {
                path: 'customer/programs/view/:id',
                element: (
                    <CustomerProtectedRoute>
                        <ProgramPage />
                    </CustomerProtectedRoute>
                ),
            },
            {
                path: 'customer/voucher-list/:id',
                element: (
                    <CustomerProtectedRoute>
                        <VoucherList />
                    </CustomerProtectedRoute>
                ),
            },
            {
                path: 'customer/voucher-distribution/:id',
                element: (
                    <CustomerProtectedRoute>
                        <ManualVoucherDistribution />
                    </CustomerProtectedRoute>
                ),
            },
        ],
    },
];

export default customerRoutes;
